import { Collapsible, NumberInput, Select } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import {
  BAY_LENGTHS,
  BAY_WIDTHS,
  setBayLen,
  setBayWidth,
  setNumBays,
  setNumLifts,
} from "../../state/generator/generator.actions.ts";
import { generatorState } from "../../state/generator/generator.state.ts";
import { Field } from "./Field.tsx";

export function LayoutSection(): JSX.Element {
  const { numBays, numLifts, bayLen, bayWidth } = generatorState.use();

  return (
    <Collapsible title="Layout" defaultOpen>
      <div className="grid grid-cols-2 gap-2">
        <Field label="Bays">
          <NumberInput value={numBays} onChange={setNumBays} min={1} max={12} step={1} />
        </Field>
        <Field label="Lifts of 2.0 m">
          <NumberInput value={numLifts} onChange={setNumLifts} min={1} max={8} step={1} />
        </Field>
        <Field label="Bay length">
          <Select
            value={String(bayLen)}
            onChange={(value) => value && setBayLen(Number(value))}
            options={BAY_LENGTHS.map((mm) => ({ value: String(mm), label: `${mm} mm` }))}
          />
        </Field>
        <Field label="Bay width">
          <Select
            value={String(bayWidth)}
            onChange={(value) => value && setBayWidth(Number(value))}
            options={BAY_WIDTHS.map((mm) => ({ value: String(mm), label: `${mm} mm` }))}
          />
        </Field>
      </div>
    </Collapsible>
  );
}
